<template>
    <div class="topHeadercont">
        <div class="leftcont">智能教学软件系统 </div>
        <ul class="rightcont">
            <li><router-link to="/account/accountInfo">我的账户</router-link></li>
            <li><router-link to="/preparationms/classExchange">我的收藏</router-link> </li>
            <li>欢迎你，{{ name }}</li>
            <li @click="logout"><i class="el-icon-switch-button" color="#000000" size="24"></i>退出登录</li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters([
            'name'
        ]),
    },
    methods: {
        logout() {
            this.$store.dispatch('LogOut').then(() => {
                location.reload() // 为了重新实例化vue-router对象 避免bug
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.topHeadercont {
    width: 100%;
    height: 70px;
    background: #FFDB58;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 15px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;

    .leftcont {
        width: 26%;
        height: 100%;
        display: flex;
        // justify-content:center;
        align-items: center;
        font-size: 24px;
        font-weight: 700;
        box-sizing: border-box;
        padding-left: 20px;
    }

    .rightcont {
        width: 48%;
        display: flex;
        justify-content: flex-end;
        ;
        align-items: center;
        // background:red;

        li {
            height: 100%;
            padding: 0 10px;
            list-style: none;
            font-size: 14px;
            display: flex;
            align-items: center;
            cursor: pointer;

            .el-icon-switch-button {
                font-weight: 700;
                margin-right: 5px;
            }
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/topHeader/index.vue